module.exports = __webpack_public_path__ + "static/img/menu3-img3.56451d4f.png";